export class DeadlinePickupDeliveryDetailExcel {
    areaCode: string;
    serviceCode:string;
    timeDelivery: number;
    timePickup: number;
}